import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { api } from 'app/modules/sfdc/api'
import { Scrollbars } from 'react-custom-scrollbars'
import { Modal, Button } from '@driftt/tide-core-legacy'

class SFDCAutomapModal extends Component {

  static propTypes = {
    isOpen: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired
  }

  state = {
    mappedUsers: {},
    loading: true
  }

  componentWillMount() {
    this.setState({ loading: true })
    api.getSalesforceAutoMappings(false).then(res => {
      const users = res['users']
      this.setState({
        mappedUsers: users || {},
        loading: false
      })
    })
  }

  mapUsersAndClose() {
    api.getSalesforceAutoMappings(true).then(res => {
      this.props.onClose(true)
    })
  }

  render() {
    const { isOpen, onClose } = this.props
    const { mappedUsers, loading } = this.state

    const mappingKeys = Object.keys(mappedUsers)

    return (

    <div>
      <Modal
        open={isOpen}
        onClose={() => onClose(false)}
        size={'small'}>
          <div className="settings-integration-automap-modal-content">
            <div className="topper">
              <div className="header">Automap Salesforce and Drift Users</div>
                <div className="copy">
                  <p className="automapping-description">The mapping below reflects either an <b>exact</b> email or name match with a drift user.</p>
                  <p className="automapping-note">Note: This may not produce a full mapping if you have over 2000 Active Salesforce Users. This will override any existing mapping. Page will refresh once complete.</p>
                    {!loading &&
                      <div>
                        <h4 className="mapping-table"><b>{mappingKeys.length}</b> Users Found:</h4>
                        <Scrollbars universal autoHide style={{ height: mappingKeys.length === 0 ? 0 : Math.min(mappingKeys.length * 50, (window.screen.height <= 720 ? 200 : 250)) }}>
                          <ul>
                            {mappingKeys.map((key, i) => {
                              return <li key={i}><b>{mappedUsers[key].email}</b></li>
                            })}
                          </ul>
                        </Scrollbars>
                      </div>
                    }
                  {loading && <p><i>Loading...</i></p>}
                </div>
              </div>
              <div className="controls">
              <Button type="secondary" size="small" onClick={() => this.mapUsersAndClose()}>
                Map users
              </Button>
              <Button type="teritiary" size="small" onClick={() => onClose(false)}>
                Cancel
              </Button>
            </div>
          </div>
      </Modal>
  </div>
    )
  }
}

export default SFDCAutomapModal


// WEBPACK FOOTER //
// ./src/scripts/components/SFDC/SFDCAutomapModal/index.js